import {
  NewFilterSummary,
  NoSearchResults,
  SummaryCardNew,
} from '@hapvida/hapvida-core-components';

import { useFilterParams } from '@hooks';

import { CoparticipationPreviewReportTable } from './components';
import type { CoparticipationPreviewCardProps } from './types';
import { CopartSearch } from '../CopartSearch';

export function CoparticipationPreviewReportCard({
  copartData,
  isLoading,
}: Readonly<CoparticipationPreviewCardProps>) {
  const { hasFilters } = useFilterParams();

  const totalListLength = copartData?.total ?? 0;

  const isEmpty = totalListLength === 0;

  const isEmptyResult = isEmpty && hasFilters;

  const filterSummaryLabel = `${totalListLength} ${
    totalListLength === 1 ? 'beneficiário' : 'beneficiários'
  }`;

  return (
    <SummaryCardNew.Container>
      <SummaryCardNew.Header title="Prévia de coparticipação" />
      <CopartSearch isLoading={isLoading} />

      <NewFilterSummary totalLabel={filterSummaryLabel} />

      {isEmptyResult && <NoSearchResults padding={5} />}
      {!isEmpty && (
        <CoparticipationPreviewReportTable copartData={copartData} />
      )}
    </SummaryCardNew.Container>
  );
}
